module.exports = __webpack_public_path__ + "static/img/avatar-s-5.50ed9b46.jpg";